import * as ApiManager from '../_manager'
import store from '@/store';


export const adminTag = {

    list: (payload = null) => {
        return ApiManager.callApi (`/admin/tag/list`,payload);
    },

    create: (payload) => {
        return ApiManager.callApi (`/admin/tag/create`, payload);
    },

    delete: (payload) => {
        return ApiManager.callApi (`/admin/tag/delete`, payload);
    },

    update: (payload) => {
    return ApiManager.callApi (`/admin/tag/update`, payload);
    },

    sync:(payload) =>{
        return ApiManager.callApi (`/admin/tag/sync`, payload);
    }

}
